class VideoChapterController {
    constructor(section) {
      this.section = section;
      this.facade = section.querySelector('[data-video-chapter-facade]');
      this.template = section.querySelector('[data-video-chapter-template]');
      this.playButton = section.querySelector('[data-video-chapter-play]');
      this.setupChapterCarousel();

      this.playButton?.addEventListener('click', () => {
        const iframe = this.template?.content.cloneNode(true);
        if (!iframe) return;

        this.facade.replaceChildren(iframe);
        this.facade.classList.add('is-playing');
      });
    }

    setupChapterCarousel() {
      const carousel = this.section.querySelector('[data-video-chapter-carousel]');
      const track = carousel?.querySelector('[data-video-chapter-track]');
      const slides = track ? [...track.querySelectorAll('[data-video-chapter-slide]')] : [];
      const previousButton = carousel?.querySelector('[data-video-chapter-previous]');
      const nextButton = carousel?.querySelector('[data-video-chapter-next]');

      if (!carousel || !track || !previousButton || !nextButton) return;

      if (slides.length < 2) {
        carousel.classList.add('is-static');
        return;
      }

      let activeSlide = 0;

      const updateCarousel = () => {
        track.style.transform = `translateX(-${activeSlide * 100}%)`;
        previousButton.disabled = activeSlide === 0;
        nextButton.disabled = activeSlide === slides.length - 1;
      };

      previousButton.addEventListener('click', () => {
        activeSlide = Math.max(activeSlide - 1, 0);
        updateCarousel();
      });

      nextButton.addEventListener('click', () => {
        activeSlide = Math.min(activeSlide + 1, slides.length - 1);
        updateCarousel();
      });

      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          track.style.transform = '';
        } else {
          updateCarousel();
        }
      });

      updateCarousel();
    }
  }

document.querySelectorAll('[data-video-chapter]').forEach((section) => {
    new VideoChapterController(section);
});